import React, { useContext, useEffect, useState } from "react";
import { TextField, makeStyles } from "@material-ui/core";
import DialogAcerBrag from "../../components/UI/DialogAcerBrag";
import LimitedBackdrop from "../../components/UI/LimitedBackdrop";
import { separations } from "../../constants/StyleConstants";
import MaterialsRequiresAPI from "../../services/MaterialsRequiresAPI";
import { LoginContext } from "../../contexts/LoginContext";
import { AppContext } from "../../contexts/AppContext";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  ...separations,
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: ".4em",
  },
  serviceSheetsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "bold",
    width: "100%",
    marginBottom: ".5em",
    padding: "0 .7em 0 .7em",
  },
  serviceSheets: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: "rgba(0,0,0,.2)",
    padding: ".3em .8em .3em .8em",
    borderRadius: "4px",
    border: "1px solid rgba(0,0,0,.2)",
  },
}));

const MaterialsFilter = ({ value, setValue, narrow }) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const pageSize = 50;
  const [displayedOptions, setDisplayedOptions] = useState([]);
  useEffect(() => {
    MaterialsRequiresAPI.getMaterials().then((res) => {
      setOptions(res);
      setDisplayedOptions(res.slice(0, pageSize));
    });
  }, []);
  useEffect(() => {
    const filteredOptions = options.filter(
      (option) =>
        option.code.includes(inputValue) ||
        option.name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setDisplayedOptions(filteredOptions.slice(0, pageSize));
  }, [inputValue, options]);

  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight ===
      listboxNode.scrollHeight
    ) {
      const currentLength = displayedOptions.length;
      const moreOptions = options.filter(
        (option) =>
          option.code.includes(inputValue) ||
          option.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      setDisplayedOptions(moreOptions.slice(0, currentLength + pageSize));
    }
  };
  return (
    <div style={{ width: narrow ? 220 : 300 }}>
      <Autocomplete
        options={displayedOptions}
        getOptionLabel={(option) => `${option.code.replace(/^0+/, "")} - ${option.name}`}
        value={value}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(event, newValue) => setValue(newValue)}
        getOptionSelected={(option, val) => option.id === val.id}
        label="Material"
        renderInput={(params) => (
          <TextField {...params} label="Material" margin="dense" />
        )}
        ListboxProps={{ onScroll: handleScroll }}
      />
    </div>
  );
};

const MaterialRequiresAddModal = ({
  openAdd,
  setOpenAdd,
  selectedRows,
  setSelectedRows,
  reloadGrid,
}) => {
  const classes = useStyles();
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { showError, showSuccess, showWarning } = useContext(AppContext);

  const [selectedMaterial, setSelectedMaterial] = useState(null);

  useEffect(() => {
    !openAdd && setSelectedMaterial(null);
  }, [openAdd]);

  const confirmRequires = () => {
    setOpenBackDrop(true);

    const request = {
      Name: selectedMaterial.name,
      Code: selectedMaterial.code,
    };

    return MaterialsRequiresAPI.insert(request)
      .then((res) => {
        showSuccess(
          "El requerimiento de certificado del material ha sido agregado correctamente"
        );
        reloadGrid();
      })
      .catch((error) => {

        let errorMsg;

        if (error.response && error.response.data) {
          errorMsg = error.response.data;
        } else {
          errorMsg =
            "Error al confirmar la agregación de los requerimientos de certificado";
        }

        showError(errorMsg, error);
      })
      .finally(() => {
        setOpenAdd(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !selectedMaterial)){
      errorMessages.push('Debe seleccionar un material');
    } 


    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  }

  const validateAndConfirm = () => validate() && confirmRequires();

  return (
    <DialogAcerBrag
      open={openAdd}
      setOpen={setOpenAdd}
      title="Agregar solicitud de certificado para los materiales"
      action={validateAndConfirm}
      actionText="Agregar"
    >
      <MaterialsFilter
        value={selectedMaterial}
        setValue={setSelectedMaterial}
      />
    </DialogAcerBrag>
  );
};
export default MaterialRequiresAddModal;
